import { GlobalState } from '../reducers';
import { TokenData } from '../reducers/userReducer';

export const getUser = (state: GlobalState) => state.user;
export const getToken = (state: GlobalState) => state.user.token;
export const getTokenData = (state: GlobalState): TokenData | null => state.user.tokenData;
